'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$EnvelopeId$() {
  this.c6w = null;
  this.c6x = false;
  this.c6u = null;
  this.c6v = false;
}
export { $c_Lpresto_types$EnvelopeId$ as $c_Lpresto_types$EnvelopeId$ };
$p = $c_Lpresto_types$EnvelopeId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$EnvelopeId$;
/** @constructor */
function $h_Lpresto_types$EnvelopeId$() {
}
export { $h_Lpresto_types$EnvelopeId$ as $h_Lpresto_types$EnvelopeId$ };
$h_Lpresto_types$EnvelopeId$.prototype = $p;
$p.cI9 = (function() {
  if ((!this.c6x)) {
    this.c6w = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.c6x = true;
  }
  return this.c6w;
});
$p.v7 = (function() {
  if ((!this.c6v)) {
    this.c6u = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c6v = true;
  }
  return this.c6u;
});
var $d_Lpresto_types$EnvelopeId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$EnvelopeId$, "presto.types$EnvelopeId$", ({
  ZW: 1,
  D: 1
}));
export { $d_Lpresto_types$EnvelopeId$ as $d_Lpresto_types$EnvelopeId$ };
var $n_Lpresto_types$EnvelopeId$;
function $m_Lpresto_types$EnvelopeId$() {
  if ((!$n_Lpresto_types$EnvelopeId$)) {
    $n_Lpresto_types$EnvelopeId$ = new $c_Lpresto_types$EnvelopeId$();
  }
  return $n_Lpresto_types$EnvelopeId$;
}
export { $m_Lpresto_types$EnvelopeId$ as $m_Lpresto_types$EnvelopeId$ };
//# sourceMappingURL=presto.types$-Envelope-Id$.js.map
